export default __webpack_public_path__ + "static/media/i163hp.879d375d.webp";